import { render, staticRenderFns } from "./password-set.vue?vue&type=template&id=6b3b81b6&scoped=true&"
import script from "./password-set.vue?vue&type=script&lang=js&"
export * from "./password-set.vue?vue&type=script&lang=js&"
import style0 from "./password-set.vue?vue&type=style&index=0&id=6b3b81b6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b81b6",
  null
  
)

export default component.exports